export default "__VITE_ASSET__Aan45r79__"